import { render, staticRenderFns } from "./SMTPServer.vue?vue&type=template&id=196def16&scoped=true&"
import script from "./SMTPServer.vue?vue&type=script&lang=js&"
export * from "./SMTPServer.vue?vue&type=script&lang=js&"
import style0 from "./SMTPServer.vue?vue&type=style&index=0&id=196def16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196def16",
  null
  
)

export default component.exports